import React from 'react';
import styled from 'styled-components';
import theme from 'styled-theming';
import { Flex, Box } from 'rebass';
import { Link } from '.';

const LINK_TO_KB_DOC = 'https://developers.liveperson.com/knowledge-base-knowledge-bases.html';

const borderColor = theme('mode', {
  light: (props) => props.theme.colors.black,
  dark: (props) => props.theme.colors.midGhost,
});

const textColor = theme('mode', {
  light: (props) => props.theme.colors.black,
  dark: (props) => props.theme.colors.midLightGrey,
});

const KB_DOCS_WRAPPER = styled(Flex)`
  width: 280px;
  border: 1px dashed ${borderColor};
  box-sizing: border-box;
  border-radius: 5px;
  padding: 10px 30px;
  color: ${textColor};
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
`;

function RecommendedActionsKBDoc() {
  return (
    <KB_DOCS_WRAPPER alignItems="center" flexDirection="column">
      <Box>You have no active Knowledge Bases</Box>
      <Link href={LINK_TO_KB_DOC} target="_blank" rel="noopener noreferrer">
        How to create a KB
      </Link>
    </KB_DOCS_WRAPPER>
  );
}

export default RecommendedActionsKBDoc;
